<template>
  <div class="fullheight" style="padding-top: 16px; height: calc(100% - 16px)">
    <eco-table
      ref="ecoTable"
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      quick-search-props="menu_name,menu_alias"
      :show-export="false"
      :defaultSorter="[{ property: 'CREATE_TIME_', direction: 'DESC' }]"
    >
      <template v-slot:toolbar>
        <el-button type="primary" size="small" @click="handleCommand({ command: 'add' })">添加</el-button>
        <fe-delete-button :url="aiConfigDeleteUrl" class="marginLeft16" :htTable="$refs.ecoTable">删除</fe-delete-button>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="menu_name" label="菜单名称" width="200" :sortable="true" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <el-link @click="handleCommand({ row: row, command: 'edit' })" type="primary">
              {{ row.menu_name }}
            </el-link>
          </template>
        </eco-table-column>
        <eco-table-column prop="menu_alias" label="菜单别名" :sortable="true" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <el-link @click="handleCommand({ row: row, command: 'edit' })" type="primary">
              {{ row.menu_alias }}
            </el-link>
          </template>
        </eco-table-column>
        <eco-table-column prop="config" label="配置" width="300" :sortable="true" :show-overflow-tooltip="true">
        </eco-table-column>
        <eco-table-column prop="createByName" label="创建人" :sortable="true" :show-overflow-tooltip="true">
        </eco-table-column>
        <eco-table-column prop="createTime" label="创建时间" :sortable="true" :show-overflow-tooltip="true">
        </eco-table-column>
        <eco-table-column width="100" label="操作">
          <template v-slot="{ row }">
            <el-link type="primary" :underline="false" @click="handleCommand({ row: row, command: 'edit' })">编辑</el-link>
          </template>
        </eco-table-column>
      </template>
    </eco-table>

    <el-dialog width="50%" :title="identiyTitle" :visible="dialogVisible" :before-close="handleClose">
      <el-form :disabled="aiConfigDisabled" v-model="aiConfig" data-vv-scope="editAiConfigForm">
        <eco-form-item label="菜单名称" prop="menu_name" label-width="120px" class="aiConfig-input-width">
          <Treeselect
              v-model="aiConfig.menu_alias"
              :normalizer="normalizer"
              @select="handleNodeClick"
              :multiple="false"
              :options="baseMenuList"
              noOptionsText=" "
              noChildrenText=" "
              placeholder="请选择父节点"
              style="width:100%;"
          />
        </eco-form-item>
        <eco-form-item label="服务器配置" label-width="120px" class="aiConfig-input-width">
          <div id="codemirror-server">
            <codemirror v-model="aiConfig.server" :options="options" ></codemirror>
          </div>
        </eco-form-item>
        <eco-form-item label="配置JSON" label-width="120px" class="aiConfig-input-width">
          <div id="codemirror-config">
            <codemirror v-model="aiConfig.config" :options="options" ></codemirror>
          </div>
        </eco-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <fe-submit-button
          v-show="!aiConfigDisabled"
          :url="saveAiConfigUrl()"
          :model="aiConfig"
          :is-submit="isSubmit"
          :request-method="requestMethod"
          scope-name="editAiConfigForm"
          @before-save-data="beforeSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
        <el-button @click="dialogCancle('dialogVisible')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <fe-load-data :url="loadDataUrl" context="portal" @after-load-data="afterLoadData"></fe-load-data>
  </div>
</template>
<script>
import portal from '@/api/portal.js'
import { codemirror } from "vue-codemirror";
import "@/components/codemirror/cm-setting.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: 'aiManage',
  components: {Treeselect, codemirror },
  data() {
    return {
      aiConfigDisabled: false,
      identiyTitle: '',
      loadDataUrl: '',
      dialogVisible: false,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      isSubmit: true,
      aiConfig: {
        menu_name: '',
        menu_alias: '',
        config: '',
        server: '',
        type: this.$route.name
      },
      configId: '',
      options: {
        line: true,
        theme: "rubyblue", // 主题
        mode: "application/json",
        lint: true,
        tabSize: 2,
        smartIndent: true, // 是否智能缩进
        styleActiveLine: true, // 当前行高亮
        lineNumbers: true, // 显示行号
        gutters: [
          "CodeMirror-linenumbers",
          "CodeMirror-foldgutter",
          "CodeMirror-lint-markers",
        ],
        lineWrapping: true, // 自动换行
        matchBrackets: true, // 括号匹配显示
        autoCloseBrackets: true, // 输入和退格时成对
        readOnly: this.readonly, // 只读
        foldGutter: true
      },
      baseMenuList: [],
      normalizer(node) {
        return {
          id: node.alias,
          label: node.name,
          children: node.children,
          isDefaultExpanded: false
        };
      },
    }
  },
  computed: {
    requestMethod: function () {
      return this.configId ? 'PUT' : 'POST'
    },
    aiConfigDeleteUrl: function () {
      return window.context.portal + '/portal_menu_expand/'
    }
  },
  watch: {
    $route: function (to, from) {
      if (to !== from) {
        this.$refs.ecoTable.load()
      }
    }
  },
  methods: {
    beforeSaveData() {
      this.isSubmit = true
    },
    saveAiConfigUrl: function () {
      return window.context.portal + '/portal_menu_expand/'
    },
    afterSaveData() {
      this.dialogVisible = false
      this.$refs.ecoTable.load()
    },
    afterLoadData(data) {
      // 编辑
      if (this.dialogVisible) {
        Object.assign(this.aiConfig, data);
        this.aiConfig.config = !data.config ? '' : JSON.stringify(JSON.parse(data.config), null, 2)
        this.aiConfig.server = !data.server ? '' : JSON.stringify(JSON.parse(data.server), null, 2)
        setTimeout(() => this.$validator.validateAll('editAiConfigForm'))
      }
    },
    dialogCancle(dialogVisible) {
      this.loadDataUrl = ''
      this[dialogVisible] = false
      setTimeout(() => (this.aiConfigDisabled = false), 500)
    },
    handleClose() {
      this.loadDataUrl = ''
      this.dialogVisible = false
      setTimeout(() => (this.aiConfigDisabled = false), 500)
    },
    showDialog(row) {
      this.dialogVisible = true
      if (row) {
        this.configId = row.id
        this.loadDataUrl = `/portal_menu_expand/${row.id}`
      }
    },
    handleNodeClick(node) {
      this.aiConfig.menu_name = node.name
    },
    loadData(param, cb) {
      portal.getCurrentMenuByAlias(this.$route.name).then((response) => {
        this.baseMenuList = response.value
      })
      if (!param.querys) {
        param.querys = [
          {
            group: 'defaultQueryGroup',
            operation: 'EQUAL',
            relation: 'AND',
            property: 'type',
            value: this.$route.name
          }
        ]
      } else {
        param.querys.push({
          group: 'defaultQueryGroup',
          operation: 'EQUAL',
          relation: 'AND',
          property: 'type',
          value: this.$route.name
        })
      }
      portal
        .getMenuExpandAll(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    handleCommand(params) {
      switch (params.command) {
        case 'edit':
          this.identiyTitle = '编辑配置'
          this.showDialog(params.row)
          break
        case 'add':
          this.configId = ''
          this.aiConfig = {
            menu_name: '',
            menu_alias: '',
            config: '',
            server: '',
            type: this.$route.name
          }
          this.identiyTitle = '添加配置'
          this.showDialog()
          break
        case 'get':
          this.identiyTitle = '查看配置'
          this.isSubmit = false
          this.aiConfigDisabled = true
          this.showDialog(params.row)
          break
        default:
          break
      }
    },
    dialogConfirm(data) {
      let aiConfigForms = []
      data.forEach((form) => {
        aiConfigForms.push({
          aiConfig_id: this.configId,
          form_key: form.formKey,
          form_id: form.id,
          form_name: form.name
        })
      })
      let param = {
        id: this.configId,
        aiConfig_forms: aiConfigForms
      }
      portal.saveMenuExpandForm(param).then((response) => {
        if (response.state) {
          this.$message.success('操作成功')
        } else {
          this.$message.error('操作失败')
        }
      })
    },
    afterDelete() {
      this.$refs.ecoTable.load()
    }
  }
}
</script>
<style scoped>
#codemirror-server {
  .CodeMirror {
    overscroll-y: scroll !important;
    height: 150px !important;
  }
}
#codemirror-config {
  .CodeMirror {
    overscroll-y: scroll !important;
    height: 500px !important;
  }
}

ul {
  padding: 0px;
  margin: 0px;
}

li {
  list-style-type: none;
}

.aiConfig-item-bottom {
  margin-bottom: 5px;
}

.aiConfig-input-width .inputs {
  width: 100%;
}
</style>
